<template>
  <div class="contanier">
    <div v-if="$isMobile()"></div>
    <div class="contanier-top" v-else>
      <a-steps size="small" :current="currentIdx" @change="onStepsChange">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
    </div>
    <div class="contanier-body">
      <div class="body-name" v-if="currentIdx === 0">
        <div style="width: 50%; padding-top: 80px">
          <div style="margin-bottom: 10px">
            {{ $t("edit.form.group.label") }}
          </div>
          <a-input
            v-model="groupName"
            :placeholder="$t('edit.form.group.placeholder')"
          ></a-input>
        </div>
      </div>
      <div class="body-image" v-else>
        <a-checkbox
          class="item-base"
          v-for="(item, index) in sceneList"
          :key="index"
          @change="onClickItem(item)"
          :checked="isChecked(item)"
        >
          <span class="item-img">
            <img :src="item.thumb_path" />
          </span>
          <span class="item-name">{{ item.scene_title }}</span>
        </a-checkbox>
      </div>
    </div>
    <div class="contanier-bottom">
      <a-button type="primary" @click="clickNext" v-if="currentIdx === 0">{{
        $t("actionTitles.next")
      }}</a-button>
      <a-button type="primary" @click="clickFinishBtn" v-else >{{
        $t("actionTitles.finish")
      }}</a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    currentNum: {
      type: Number,
      default: 0,
    },
    existingGroup: {
      type: Object,
    },
    currGroupIndex:{
      type: Number
    }
  },
  data() {
    return {
      steps: [
        {
          title: this.$t("edit.form.group.title1"),
          content: "First-content",
        },
        {
          title: this.$t("edit.form.group.title2"),
          content: "Second-content",
        },
      ],
      currentIdx: 0,
      groupName: "",
      sceneList: [],
      selectedList: [],
    };
  },
  created() {
    this.sceneList = this.$deepClone(this.vrbase.scenes);
    this.currentIdx = this.currentNum;
    //已有分組 編輯場景
    if (this.existingGroup && Object.keys(this.existingGroup).length) {
      this.groupName = this.$deepClone(this.existingGroup.name);
      this.selectedList = this.$deepClone(this.existingGroup.scenes);
    }
  },
  mouted() {},
  computed: { ...mapGetters(["vrbase", "userInfo"]) },
  methods: {
    onStepsChange(current) {
      if (this.currentIdx === 0 && this.groupName === "") {
        this.$message.error(this.$t("edit.form.group.label"));
        return;
      }
      this.currentIdx = current;
    },
    clickNext() {
      if (this.currentIdx === 0 && this.groupName === "") {
        this.$message.error(this.$t("edit.form.group.label"));
        return;
      }
      this.currentIdx = 1;
    },
    //保存
    async clickFinishBtn() {
      if (this.groupName === "" || this.selectedList.length === 0) {
        this.$message.error(this.$t("edit.editMessage.completeInfo"));
        return;
      }
      //去掉重複數據
      await this.hanhleGroupData();
      //獲取選擇的場景id
      const resultSences = this.selectedList.map((item) => item);
      const result = {
        name: this.groupName,
        scenes: resultSences,
      };
      // 編輯場景 or 新增場景
      if (this.existingGroup) {
        if(this.existingGroup.id){
          this.vrbase.scene_group.groups.forEach((item) => {
            if (item.id === this.existingGroup.id) {
              item.scenes = result.scenes;
              item.name=result.name;
            }
          });
        }else{
          this.$set(this.vrbase.scene_group.groups[this.currGroupIndex],'name',result.name)
          this.$set(this.vrbase.scene_group.groups[this.currGroupIndex],'scenes',result.scenes)
        }
      } else {
        this.vrbase.scene_group.groups.push(result);
      }
      console.log("===000group====", this.vrbase.scene_group.groups, result)
      //更新服務器
      this.$emit("closeModal");
    },
    // 保存的時候，判斷現在的分組中是否有重複選擇的，有則去掉，沒有直接添加
    hanhleGroupData() {
      return new Promise((resolve, reject) => {
        const currentGroup = this.vrbase.scene_group.groups;
        for (let i = 0; i < currentGroup.length; i++) {
          if(this.existingGroup){
            if((this.existingGroup.id && this.existingGroup.id == currentGroup[i].id) || this.currGroupIndex == i){
              continue;
            }
          }
          const currIdxScenes = currentGroup[i].scenes;
          //選擇的列表
          for (let j = 0; j < this.selectedList.length; j++) {
            const selected = this.selectedList[j];
            const delIdx = currIdxScenes.indexOf(selected);
            if (delIdx > -1) {
              currIdxScenes.splice(delIdx, 1);
            }
          }
        }
        resolve();
      });
    },
    onClickItem(item) {
      this.handleSelectResult(item);
    },
    // 處理用戶選擇的結果
    handleSelectResult(result) {
      const isExist = this.selectedList.findIndex(
        (item) => item === result.scene_id
      );
      console.log(isExist);
      if (isExist > -1) {
        this.selectedList.splice(isExist, 1);
      } else {
        this.selectedList.push(result.scene_id);
      }
    },
    isChecked(item) {
      if(this.selectedList && this.selectedList.length){
        return this.selectedList.findIndex((v) => v == item.id) > -1;
      }else{
        return false
      }
    },
  },
};
</script>

<style lang="less" scoped>
.contanier {
  .contanier-top {
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    max-width: 400px;
    margin: 0 auto;
    display: flex;
    .contanier-step {
      flex: 1;
      line-height: 32px;
      text-align: center;
    }
    .active {
      background: rgb(253, 228, 40);
      color: #494a51;
    }
  }
  .contanier-body {
    height: 250px;
    background: #f3f3f3;
    border-radius: 5px;
    padding: 10px;
    margin-top: 10px;
    overflow: auto;
    .body-name {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .body-image {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }
  }
  .contanier-bottom {
    padding: 20px 0;
    text-align: center;
    .nextBtn {
      background-color: #7101ad;
      border-color: #7101ad;
    }
  }
}
.item-base {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 33%;
  height: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding: 10px 0;
}
@media (max-width: 767px) {
  .item-base {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
    height: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding: 10px 0;
  }
}
.material-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.item-img {
  border-radius: 5px;
  margin-right: 5px;
}
.item-img img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}
.item-name {
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0px;
}
</style>
